<template>
  <section class="app-section"
           id="depts">
    <div>
      <div style="margin-top:10px;">
        <el-tabs v-model="tabActiveName">
          <el-tab-pane label="科室信息"
                       name="first">
            <div style="display:-webkit-flex;display:flex;">
              <div style="width:250px;padding-right:20px;border-right:solid 2px #ddd;">
                <el-input placeholder="输入关键字进行过滤"
                          v-model="filterText"
                          style="padding:10px 0;"
                          size="small">
                </el-input>
                <el-tree v-loading="TreeLoading"
                         class="filter-tree"
                         :data="list"
                         :props="defaultProps"
                         :show-checkbox="false"
                         :highlight-current="true"
                         node-key="id"
                         :default-expand-all="true"
                         :filter-node-method="filterNode"
                         :expand-on-click-node="false"
                         :render-content="renderContent"
                         ref="treeDept"
                         @node-click="handleNodeClick">
                </el-tree>
              </div>
              <div style="-webkit-flex:1;flex:1;padding-left:20px;">
                <el-form ref="form"
                         label-width="80px"
                         class="editInfo"
                         size="small">
                  <el-form-item style="text-align:right;">
                    <el-button type="primary"
                               @click="notEditing = false"
                               v-if="notEditing && editForm.id !== 0 && editForm.id !== undefined">编辑科室信息</el-button>
                    <el-button type="primary"
                               v-if="notEditing && (editForm.id === 0 || editForm.id === undefined)"
                               disabled>编辑科室信息</el-button>
                    <el-button type="primary"
                               @click="editSave"
                               v-if="!notEditing">保存</el-button>
                    <el-button @click="notEditing = true"
                               v-if="!notEditing">取消</el-button>
                  </el-form-item>

                  <el-form-item label="科室名称:"
                                style="display:inline-block;width:32%;">
                    <el-input v-model="editForm.name"
                              v-if="!notEditing"></el-input>
                    <span v-if="notEditing">{{info.name}}</span>
                  </el-form-item>
                  <el-form-item label="科室编号:"
                                style="display:inline-block;width:30%;">
                    <el-input v-model="editForm.code"
                              v-if="!notEditing"></el-input>
                    <span v-if="notEditing">{{info.code}}</span>
                  </el-form-item>
                  <el-form-item label="科室类型:"
                                style="display:inline-block;width:30%;">
                    <el-input v-model="editForm.type"
                              v-if="!notEditing"></el-input>
                    <span v-if="notEditing">{{info.type}}</span>
                  </el-form-item>
                  <el-form-item label="科室地址:"
                                style="display:inline-block;width:32%;">
                    <el-input v-model="editForm.location"
                              v-if="!notEditing"></el-input>
                    <span v-if="notEditing">{{info.location}}</span>
                  </el-form-item>
                  <el-form-item label="科室电话:"
                                style="display:inline-block;width:30%;">
                    <el-input v-model="editForm.phone"
                              v-if="!notEditing"></el-input>
                    <span v-if="notEditing">{{info.phone}}</span>
                  </el-form-item>
                  <el-form-item label="科室排序:"
                                style="display:inline-block;width:30%;">
                    <el-input v-model="editForm.sort_no"
                              v-if="!notEditing"></el-input>
                    <span v-if="notEditing">{{info.sort_no || '--'}}</span>
                  </el-form-item>
                  <el-form-item label="科室简介:">
                    <!-- <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 10}" v-model="editForm.intro" v-if="!notEditing"></el-input> -->
                    <div v-show="!notEditing">
                      <div id="deptsContentMenu"
                           class="w-e-toolbar"></div>
                      <div id="deptsContent"
                           class="deptsContent"></div>
                    </div>
                    <span v-if="notEditing"
                          v-html="info.intro"></span>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="科室分布"
                       name="second">
            <div style="display:flex;display:-webkit-flex;">
              <div style="width:250px;padding-right:20px;border-right:solid 2px #ddd;">
                <el-tree v-loading="buildingsTreeLoading"
                         class="filter-tree"
                         :data="deptLayList"
                         :props="deptLayProps"
                         :show-checkbox="false"
                         :highlight-current="true"
                         node-key="id"
                         :default-expand-all="true"
                         :expand-on-click-node="false"
                         :render-content="deptLayRenderContent"
                         ref="tree"
                         @node-click="deptLayHandleNodeClick">
                </el-tree>
                <div style="text-align:center;border-top:solid 1px #eee;margin-top:8px;padding:10px 0;">
                  <el-button @click="deptDialogVisible = true"><i class="el-icon-plus"></i> 添加</el-button>
                </div>
              </div>
              <div style="-webkit-flex:1;flex:1;padding-left:20px;padding-right:20px;">
                <div style="height:40px;line-height:40px;display:-webkit-flex;border-bottom:1px solid rgb(221, 221, 221);">
                  <span style="flex: 1 1 0%;">{{activeBuilding.name || ''}}（ID:{{activeBuilding.id || ''}}）</span>
                </div>
                <el-table :data="floorLayList"
                          style="width: 100%"
                          v-loading="tableLoading">
                  <el-table-column label="楼层"
                                   width="100">
                    <template slot-scope="scope">{{scope.row.floor_number}}F</template>
                  </el-table-column>
                  <el-table-column prop="depts"
                                   label="科室">
                  </el-table-column>
                  <el-table-column label="操作"
                                   width="100">
                    <template slot-scope="scope">
                      <el-button style='font-size:12px;'
                                 type='text'
                                 @click="editFloorFunc(scope.row)"><i class="el-icon-edit"></i></el-button>
                      <el-button style='font-size:12px;'
                                 type='text'
                                 @click="removeFloor(scope.row)"><i class="el-icon-delete"></i></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="text-align:center;margin-top:8px;padding:10px 0;"
                     v-if="deptLayList.length !== 0">
                  <el-button @click="floorDialogVisible = true;newFloor.floor_number = floorLayList.length + 1"><i class="el-icon-plus"></i> 添加</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!--添加建筑的对话框-->
        <el-dialog title="添加建筑"
                   :visible.sync="deptDialogVisible"
                   :append-to-body="true">
          <el-form ref="form"
                   label-width="100px">
            <el-form-item label="建筑名称">
              <el-input v-model="newDeptName"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="deptDialogVisible = false">取 消</el-button>
            <el-button type="primary"
                       @click="newBuilding()">确 定</el-button>
          </div>
        </el-dialog>

        <!--编辑建筑的对话框-->
        <el-dialog title="编辑建筑"
                   :append-to-body="true"
                   :visible.sync="editDeptDialogVisible">
          <el-form ref="form"
                   label-width="100px">
            <el-form-item label="建筑名称">
              <el-input v-model="editDept.name"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="editDeptDialogVisible = false">取 消</el-button>
            <el-button type="primary"
                       @click="editDeptSubmit()">确 定</el-button>
          </div>
        </el-dialog>

        <!--添加楼层的对话框-->
        <el-dialog title="添加楼层"
                   :append-to-body="true"
                   :visible.sync="floorDialogVisible">
          <el-form ref="form"
                   label-width="100px">
            <el-form-item label="楼层序列">
              <el-input-number v-model="newFloor.floor_number"
                               :min="1"></el-input-number> F
            </el-form-item>
            <el-form-item label="科室">
              <el-input type="textarea"
                        :autosize="{ minRows: 4, maxRows: 8}"
                        v-model="newFloor.depts"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="floorDialogVisible = false">取 消</el-button>
            <el-button type="primary"
                       @click="newFloorFunc()">确 定</el-button>
          </div>
        </el-dialog>

        <!--编辑楼层的对话框-->
        <el-dialog title="编辑楼层"
                   :append-to-body="true"
                   :visible.sync="editFloorDialogVisible">
          <el-form ref="form"
                   label-width="100px">
            <el-form-item label="楼层序列">
              <el-input-number v-model="editFloor.floor_number"
                               :min="1"></el-input-number> F
            </el-form-item>
            <el-form-item label="科室">
              <el-input type="textarea"
                        :autosize="{ minRows: 4, maxRows: 8}"
                        v-model="editFloor.depts"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="editFloorDialogVisible = false">取 消</el-button>
            <el-button type="primary"
                       @click="editFloorSubmit()">确 定</el-button>
          </div>
        </el-dialog>

        <!--添加科室的对话框-->
        <el-dialog title="添加科室"
                   :append-to-body="true"
                   :visible.sync="dialogFormVisible"
                   width="60%">
          <el-form ref="form"
                   label-width="100px"
                   size="small">
            <el-form-item label="父科室名称">
              <el-input v-model="parentNode.name"
                        disabled></el-input>
            </el-form-item>
            <el-form-item label="科室名称"
                          style="display:inline-block;width:32%;">
              <span style="position: absolute;left: -80px;color:red">*</span>
              <el-input v-model="addForm.name"></el-input>
            </el-form-item>
            <el-form-item label="科室编号"
                          style="display:inline-block;width:30%;">
              <el-input v-model="addForm.code"></el-input>
            </el-form-item>
            <el-form-item label="科室类型"
                          style="display:inline-block;width:30%;">
              <el-input v-model="addForm.type"></el-input>
            </el-form-item>
            <el-form-item label="科室地址"
                          style="display:inline-block;width:46%;">
              <el-input v-model="addForm.location"></el-input>
            </el-form-item>
            <el-form-item label="科室电话"
                          style="display:inline-block;width:46%;">
              <el-input v-model="addForm.phone"></el-input>
            </el-form-item>

            <el-form-item label="科室简介">
              <span style="position: absolute;left: -80px;color:red">*</span>
              <div style="border: 1px solid #dddddd;height: 300px;overflow-y: scroll;">
                <div id="deptAddContentMenu"
                     class="w-e-toolbar"></div>
                <div id="deptAddContent"
                     class="deptAddContent"></div>
              </div>
              <!-- <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 10}" v-model="addForm.intro"></el-input> -->

            </el-form-item>
          </el-form>
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary"
                       @click="appendSubmit">添 加</el-button>
          </div>
        </el-dialog>
        <div>

        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
import { Loading } from 'element-ui'
import qs from 'qs'
// import jQuery from 'jquery'
import E from 'wangeditor'

export default {
  name: 'depts',
  data: function () {
    return {
      tabActiveName: 'first',
      TreeLoading: true,
      filterText: '',
      list: [],
      defaultProps: {
        children: 'depts',
        label: 'name',
      },
      info: {},
      editForm: {},
      notEditing: true,
      parentNode: {},
      dialogFormVisible: false,
      addForm: {
        name: '',
        code: '',
        type: '',
        location: '',
        phone: '',
        intro: '',
        sort_no: '',
      },
      buildingsTreeLoading: true,
      deptLayList: [],
      activeBuilding: {},
      deptLayProps: {
        label: 'name',
      },
      floorsTreeLoading: true,
      floorLayList: [],
      tableLoading: true,
      deptDialogVisible: false,
      newDeptName: '',
      editDeptDialogVisible: false,
      editDept: {},
      floorDialogVisible: false,
      newFloor: {},
      editFloorDialogVisible: false,
      editFloor: {},
      editorEdit: {},
      editorAdd: {},
      flag: false,
    }
  },
  watch: {
    filterText(val) {
      this.$refs.treeDept.filter(val)
    },
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    editDeptFunc(data) {
      this.editDeptDialogVisible = true
      this.editDept = JSON.parse(JSON.stringify(data))
    },
    editDeptSubmit() {
      if (this.editDept.name.replace(/\s/g, '') === '') {
        this.$message({
          showClose: true,
          message: '请填写建筑名称',
          type: 'warning',
        })
        return
      }
      let loadingInstance = Loading.service({ fullscreen: false })
      let self = this
      this.$utils.caringRequest({
        method: 'PUT',
        url: this.$utils.getInterface('BUILDING') + '/' + this.editDept.id,
        data: {
          name: this.editDept.name,
        },
        auth: true,
        success: (res) => {
          loadingInstance.close()
          if (res.code === 0) {
            self.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
            })
            self.editDeptDialogVisible = false
            self.getBuildings()
          } else {
            self.$notify.error({
              title: '错误',
              message: 'ERROR（' + res.code + '）：' + res.message,
            })
          }
        },
      })
    },
    newBuilding() {
      if (this.newDeptName.replace(/\s/g, '') === '') {
        this.$message({
          showClose: true,
          message: '请填写建筑名称',
          type: 'warning',
        })
        return
      }
      let loadingInstance = Loading.service({ fullscreen: false })
      let self = this

      this.$utils.caringRequest({
        method: 'POST',
        url: this.$utils.getInterface('BUILDING') + '?name=' + this.newDeptName,
        auth: true,
        success: (res) => {
          loadingInstance.close()
          if (res.code === 0) {
            self.$notify({
              title: '成功',
              message: '添加成功',
              type: 'success',
            })
            self.deptDialogVisible = false
            self.newDeptName = ''
            self.getBuildings()
          } else {
            self.$notify.error({
              title: '错误',
              message: 'ERROR（' + res.code + '）：' + res.message,
            })
          }
        },
      })
    },
    removeDept(node, data) {
      let self = this
      this.$confirm('确定删除该建筑?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let loadingInstance = Loading.service({ fullscreen: false })
        this.$utils.caringRequest({
          method: 'DELETE',
          url: this.$utils.getInterface('BUILDING') + '/' + data.id,
          auth: true,

          success: (res) => {
            loadingInstance.close()
            if (res.code === 0) {
              self.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success',
              })
              self.getBuildings()
            } else {
              self.$notify.error({
                title: '错误',
                message: 'ERROR（' + res.code + '）：' + res.message,
              })
            }
          },
        })
      })
    },
    newFloorFunc() {
      if (isNaN(this.newFloor.floor_number)) {
        this.$message({
          showClose: true,
          message: '请填写正确的楼层序列',
          type: 'warning',
        })
        return
      }
      if (this.newFloor.depts.replace(/\s/g, '') === '') {
        this.$message({
          showClose: true,
          message: '请填写科室',
          type: 'warning',
        })
        return
      }
      let loadingInstance = Loading.service({ fullscreen: false })
      let self = this

      this.$utils.caringRequest({
        method: 'POST',
        url:
          this.$utils.getInterface('FLOOR') +
          '?buildingId=' +
          this.activeBuilding.id +
          '&depts=' +
          this.newFloor.depts +
          '&floorNumber=' +
          this.newFloor.floor_number,
        auth: true,

        success: (res) => {
          loadingInstance.close()
          if (res.code === 0) {
            self.$notify({
              title: '成功',
              message: '添加成功',
              type: 'success',
            })
            self.floorDialogVisible = false
            self.newFloor.floor_number = self.floorLayList.length + 2
            self.newFloor.depts = ''
            self.getFloors(self.activeBuilding.id)
          } else {
            self.$notify.error({
              title: '错误',
              message: 'ERROR（' + res.code + '）：' + res.message,
            })
          }
        },
      })
    },
    editFloorFunc(data) {
      this.editFloorDialogVisible = true
      this.editFloor = JSON.parse(JSON.stringify(data))
    },

    editFloorSubmit(data) {
      if (isNaN(this.editFloor.floor_number)) {
        this.$message({
          showClose: true,
          message: '请填写正确的楼层序列',
          type: 'warning',
        })
        return
      }
      if (this.editFloor.depts.replace(/\s/g, '') === '') {
        this.$message({
          showClose: true,
          message: '请填写科室',
          type: 'warning',
        })
        return
      }
      let loadingInstance = Loading.service({ fullscreen: false })
      let self = this

      this.$utils.caringRequest({
        method: 'PUT',
        url: this.$utils.getInterface('FLOOR') + '/' + this.editFloor.id,
        auth: true,
        data: {
          building_id: this.activeBuilding.id,
          depts: this.editFloor.depts,
          floor_number: this.editFloor.floor_number,
        },
        success: (res) => {
          loadingInstance.close()
          if (res.code === 0) {
            self.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
            })
            self.editFloorDialogVisible = false
            self.getFloors(self.activeBuilding.id)
          } else {
            self.$notify.error({
              title: '错误',
              message: 'ERROR（' + res.code + '）：' + res.message,
            })
          }
        },
      })
    },
    removeFloor(data) {
      let self = this
      this.$confirm('确定删除该楼层?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let loadingInstance = Loading.service({ fullscreen: false })
        this.$utils.caringRequest({
          method: 'DELETE',
          url: this.$utils.getInterface('FLOOR') + '/' + data.id,
          auth: true,

          success: (res) => {
            loadingInstance.close()
            if (res.code === 0) {
              self.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success',
              })
              self.getFloors(self.activeBuilding.id)
            } else {
              self.$notify.error({
                title: '错误',
                message: 'ERROR（' + res.code + '）：' + res.message,
              })
            }
          },
        })
      })
    },
    deptLayHandleNodeClick(data) {
      // console.log(data)
      this.activeBuilding = data
      this.getFloors(data.id)
    },
    deptLayRenderContent(h, { node, data, store }) {
      return (
        <span class="cc-tree">
          <span>
            <span>
              <i class="fa fa-h-square" aria-hidden="true"></i>
              {node.label}
            </span>
          </span>
          <span>
            <el-popover ref="groupPopover" placement="right" trigger="hover">
              <div style="border-bottom:solid 1px #ddd;line-height:36px;">
                {node.label}
                <span style="color:#bbb;">（ID:{data.id}）</span>
              </div>
              <div>
                <el-button type="text" on-click={() => this.editDeptFunc(data)}>
                  编辑
                </el-button>
              </div>
              <div>
                <el-button
                  type="text"
                  on-click={() => this.removeDept(node, data)}
                >
                  删除
                </el-button>
              </div>
              <el-button type="text" slot="reference">
                <i class="el-icon-more iconc" aria-hidden="true"></i>
              </el-button>
            </el-popover>
          </span>
        </span>
      )
    },
    editSave() {
      let editForm = this.editForm
      let name = editForm.name ? editForm.name.replace(/\s/g, '') : ''
      let code = editForm.code ? editForm.code.replace(/\s/g, '') : ''
      let type = editForm.type ? editForm.type.replace(/\s/g, '') : ''
      let location = editForm.location
        ? editForm.location.replace(/\s/g, '')
        : ''
      let phone = editForm.phone ? editForm.phone.replace(/\s/g, '') : ''
      let sort_no = editForm.sort_no ? editForm.sort_no : ''

      let intro = this.editorEdit.txt.html()
      //       let intro =
      //         '<div style="font-size:16px;line-height:1.6" class="chinacaring-style">' +
      //         this.editorEdit.txt.html() +
      //         '</div>' // 特别注意：由于wangeditor v3没有支持line-height和font-size，所以需要自己css设置，于是我们在编辑器区域设置font-size:16px;line-height:1.6; 在获取编辑器html同时，在最外层包裹<div style="font-size:16px;line-height:1.6" class="chinacaring-style"></div>，以达到同编辑框样式一致的效果,chinacaring-style为了增加内容样式可编辑性
      if (!name) {
        this.$message({
          showClose: true,
          message: '请填写科室名称',
          type: 'warning',
        })
        return
      }
      if (!code) {
        this.$message({
          showClose: true,
          message: '请填写科室编号',
          type: 'warning',
        })
        return
      }
      if (!type) {
        this.$message({
          showClose: true,
          message: '请填写科室类型',
          type: 'warning',
        })
        return
      }
      if (!location) {
        this.$message({
          showClose: true,
          message: '请填写科室地址',
          type: 'warning',
        })
        return
      }
      if (!phone) {
        this.$message({
          showClose: true,
          message: '请填写科室电话',
          type: 'warning',
        })
        return
      }
      if (!sort_no) {
        this.$message({
          showClose: true,
          message: '请填写科室排序',
          type: 'warning',
        })
        return
      }
      if (!intro) {
        this.$message({
          showClose: true,
          message: '请填写科室简介',
          type: 'warning',
        })
        return
      }
      let loadingInstance = Loading.service({ fullscreen: false })
      let self = this
      this.$utils.caringRequest({
        method: 'PUT',
        url: this.$utils.getInterface('DEPTEDIT'),
        auth: true,
        data: {
          id: this.editForm.id,
          name: name,
          code: code,
          type: type,
          location: location,
          phone: phone,
          sort_no,
          image: null,
          pid: this.editForm.pid,
          intro: intro,
        },
        success: (res) => {
          loadingInstance.close()
          if (res.code === 0) {
            self.info = JSON.parse(JSON.stringify(self.editForm))
            self.info.intro = self.editorEdit.txt.html()
            self.notEditing = true
            self.getDeptList()
            self.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
            })
          } else {
            self.$notify.error({
              title: '错误',
              message: 'ERROR（' + res.code + '）：' + res.message,
            })
          }
        },
      })
    },
    handleNodeClick(data) {
      // console.log(data)
      if (!this.notEditing) {
        this.$confirm(
          '您当前正在编辑科室信息，切换科室将丢失当前已编辑信息，是否确定离开?',
          '提示',
          {
            confirmButtonText: '确定离开',
            cancelButtonText: '留在此页',
            type: 'warning',
          }
        ).then(() => {
          this.info = JSON.parse(JSON.stringify(data))
          this.editForm = JSON.parse(JSON.stringify(data))
          this.editorEdit.txt.html(this.editForm.intro)
          this.notEditing = true
        })
      } else {
        this.info = JSON.parse(JSON.stringify(data))
        this.editForm = JSON.parse(JSON.stringify(data))
        this.editorEdit.txt.html(this.editForm.intro)
      }
    },
    renderContent(h, { node, data, store }) {
      //       console.log(data)
      if (data.depts.length !== 0 || data.id === 0) {
        console.log
        return (
          <span class="cc-tree">
            <span>
              <span>{node.label}</span>
            </span>
            <span>
              <el-popover ref="groupPopover" placement="right" trigger="hover">
                <div style="border-bottom:solid 1px #ddd;line-height:36px;">
                  {node.label}
                  <span style="color:#bbb;">（ID:{data.id}）</span>
                </div>
                <div>
                  <el-button type="text" on-click={() => this.append(data)}>
                    添加子科室
                  </el-button>
                </div>
                <el-button type="text" slot="reference">
                  <i class="el-icon-more iconc" aria-hidden="true"></i>
                </el-button>
              </el-popover>
            </span>
          </span>
        )
      } else {
        return (
          <span class="cc-tree">
            <span>
              <span>
                <i class="fa fa-heartbeat" aria-hidden="true"></i>
                {node.label}
              </span>
            </span>
            <span>
              <el-popover ref="groupPopover" placement="right" trigger="hover">
                <div style="border-bottom:solid 1px #ddd;line-height:36px;">
                  {node.label}
                  <span style="color:#bbb;">（ID:{data.id}）</span>
                </div>
                <div>
                  <el-button type="text" on-click={() => this.append(data)}>
                    添加子科室
                  </el-button>
                </div>
                <div>
                  <el-button
                    type="text"
                    on-click={() => this.remove(node, data)}
                  >
                    删除
                  </el-button>
                </div>
                <el-button type="text" slot="reference">
                  <i class="el-icon-more iconc" aria-hidden="true"></i>
                </el-button>
              </el-popover>
            </span>
          </span>
        )
      }
    },
    append(data) {
      this.parentNode = data
      this.dialogFormVisible = true
      if (this.flag) return // 如果之前已经创建过编辑器，就不重复创建了

      setTimeout(() => {
        var self = this
        var editorConfig = {
          debug: true,
          menus: [
            // 'head',  // 标题
            'bold', // 粗体
            'italic', // 斜体
            'underline', // 下划线
            // 'strikeThrough',  // 删除线
            'foreColor', // 文字颜色
            'backColor', // 背景颜色
            'link', // 插入链接
            // 'list',  // 列表
            'justify', // 对齐方式
            // 'quote',  // 引用
            // 'emoticon',  // 表情
            'image', // 插入图片
            'table', // 表格
            // 'video',  // 插入视频
            // 'code',  // 插入代码
            'undo', // 撤销
            'redo', // 重复
          ],
          pasteFilterStyle: true, // 粘贴样式的过滤
          uploadImgHeaders: {
            Authorization: self.$store.state.Authorization, // editor上传图片配置
            tenant: this.$store.state.is_platform
              ? '9999'
              : this.$store.state.tenant.tenant,
          },
          uploadFileName: 'file',
          uploadImgMaxLength: 1, // 限制一次最多上传 1 张图片
          uploadImgServer: self.$store.state.uploadImgServer,
          uploadImgHooks: {
            customInsert: function (insertImg, result, editor) {
              // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
              // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
              if (result.code === 0) {
                let url = self.$store.state.fileDIR + result.data
                insertImg(url)
              } else {
                self.$message.error(result.message)
              }
            },
          },
          zIndex: 1,
          customAlert: function (info) {
            // info 是需要提示的内容
            self.$message.error(info)
          },
        }

        var editorAdd = new E('#deptAddContentMenu', '#deptAddContent')
        editorAdd.customConfig = editorConfig
        this.editorAdd = editorAdd

        self.editorAdd.create()
        self.flag = true
      })
    },
    appendSubmit() {
      let name = this.addForm.name.replace(/\s/g, '')
      let code = this.addForm.code.replace(/\s/g, '')
      let type = this.addForm.type.replace(/\s/g, '')
      let location = this.addForm.location.replace(/\s/g, '')
      let phone = this.addForm.phone.replace(/\s/g, '')
      let intro = this.editorAdd.txt.html()
      //       let intro =
      //         '<div style="font-size:16px;line-height:1.6" class="chinacaring-style">' +
      //         this.editorAdd.txt.html() +
      //         '</div>'
      if (!name) {
        this.$message({
          showClose: true,
          message: '请填写科室名称',
          type: 'warning',
        })
        return
      }
      //       if (!code) {
      //         this.$message({
      //           showClose: true,
      //           message: '请填写科室编号',
      //           type: 'warning',
      //         })
      //         return
      //       }
      //       if (!type) {
      //         this.$message({
      //           showClose: true,
      //           message: '请填写科室类型',
      //           type: 'warning',
      //         })
      //         return
      //       }
      //       if (!location) {
      //         this.$message({
      //           showClose: true,
      //           message: '请填写科室地址',
      //           type: 'warning',
      //         })
      //         return
      //       }
      //       if (!phone) {
      //         this.$message({
      //           showClose: true,
      //           message: '请填写科室电话',
      //           type: 'warning',
      //         })
      //         return
      //       }
      console.log(intro)
      if (!intro) {
        this.$message({
          showClose: true,
          message: '请填写科室简介',
          type: 'warning',
        })
        return
      }
      let loadingInstance = Loading.service({ fullscreen: false })
      let self = this
      let obj = {
        name: name,
        code: code,
        type: type,
        location: location,
        phone: phone,
        image: null,
        pid: this.parentNode.id,
        intro: intro,
      }
      this.$utils.caringRequest({
        method: 'POST',
        url: this.$utils.getInterface('DEPTEDIT') + '?' + qs.stringify(obj),
        auth: true,

        success: (res) => {
          loadingInstance.close()
          if (res.code === 0) {
            self.getDeptList()
            self.dialogFormVisible = false
            self.addForm = {}
            self.editorAdd.txt.html('<p><br></p>')
            self.$notify({
              title: '成功',
              message: '添加成功',
              type: 'success',
            })
          } else {
            self.$notify.error({
              title: '错误',
              message: 'ERROR（' + res.code + '）：' + res.message,
            })
          }
        },
      })
    },
    remove(node, data) {
      this.$confirm('确定删除该科室?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'DELETE',
      }).then(() => {
        let self = this

        this.$utils.caringRequest({
          method: 'DELETE',
          url: this.$utils.getInterface('DEPTEDIT') + '/' + data.id,
          auth: true,
          success: (res) => {
            if (res.code === 0) {
              self.$message({
                message: '删除成功',
                type: 'success',
              })
              const parent = node.parent
              const depts = parent.data.depts || parent.data
              const index = depts.findIndex((d) => d.id === data.id)
              depts.splice(index, 1)
            } else {
              self.$message.error('删除失败：' + res.message)
            }
          },
        })
      })
    },
    getDeptList() {
      this.TreeLoading = true
      let self = this
      this.$utils.caringRequest({
        method: 'GET',
        url: this.$utils.getInterface('DEPTSINFO'),
        auth: true,
        success: (res) => {
          self.TreeLoading = false
          res.data.forEach((item) => {
            item.sort_no = item.sort_no || ''
          })
          self.list = []
          self.list.push({
            id: 0,
            name: self.$store.state.shift.institution_name,
            code: '--',
            type: '--',
            location: '--',
            phone: '--',
            image: null,
            pid: 0,
            intro: '--',
            depts: res.data,
          })
          // console.log(self.list)
          // console.log(self.editForm)
          if (!self.editForm.id) {
            self.info = JSON.parse(JSON.stringify(self.list[0]))
            self.editForm = JSON.parse(JSON.stringify(self.list[0]))
            self.editorEdit.txt.html(self.editForm.intro)
          }
        },
      })
    },
    getBuildings() {
      this.buildingsTreeLoading = true
      var self = this
      this.$utils.caringRequest({
        method: 'GET',
        url: this.$utils.getInterface('BUILDINGS'),
        auth: true,
        success: (res) => {
          console.log(11154, res)
          self.buildingsTreeLoading = false
          if (res.code === 0) {
            if (res.data.length === 0) {
              self.deptLayList = []
              self.floorLayList = []
              self.tableLoading = false
            } else {
              self.deptLayList = res.data
              self.activeBuilding = self.deptLayList[0]
              self.getFloors(self.deptLayList[0].id)
            }
          } else {
            self.deptLayList = []
            self.activeBuilding = {}
            self.tableLoading = false
            self.$notify.error({
              title: '错误',
              message: 'ERROR（' + res.code + '）：' + res.message,
            })
          }
        },
      })
    },
    getFloors(buildingId) {
      this.tableLoading = true
      var self = this

      this.$utils.caringRequest({
        method: 'GET',
        url: this.$utils.getInterface('FLOORS') + '/' + buildingId,
        auth: true,
        success: (res) => {
          self.tableLoading = false
          if (res.code === 0) {
            self.floorLayList = res.data
          } else {
            self.floorLayList = []
            self.$notify.error({
              title: '错误',
              message: 'ERROR（' + res.code + '）：' + res.message,
            })
          }
        },
      })
    },
  },
  mounted: function () {
    this.getDeptList()
    this.getBuildings()
    var self = this
    var editorConfig = {
      debug: true,
      menus: [
        // 'head',  // 标题
        'bold', // 粗体
        'italic', // 斜体
        'underline', // 下划线
        // 'strikeThrough',  // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        // 'list',  // 列表
        'justify', // 对齐方式
        // 'quote',  // 引用
        // 'emoticon',  // 表情
        'image', // 插入图片
        'table', // 表格
        // 'video',  // 插入视频
        // 'code',  // 插入代码
        'undo', // 撤销
        'redo', // 重复
      ],
      pasteFilterStyle: true, // 粘贴样式的过滤
      uploadImgHeaders: {
        Authorization: self.$store.state.Authorization, // editor上传图片配置
        tenant: this.$store.state.is_platform
          ? '9999'
          : this.$store.state.tenant.tenant,
      },
      uploadFileName: 'file',
      uploadImgMaxLength: 1, // 限制一次最多上传 1 张图片
      uploadImgServer: self.$store.state.uploadImgServer,
      uploadImgHooks: {
        customInsert: function (insertImg, result, editor) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
          if (result.code === 0) {
            let url = self.$store.state.fileDIR + result.data
            insertImg(url)
          } else {
            self.$message.error(result.message)
          }
        },
      },
      zIndex: 1,
      customAlert: function (info) {
        // info 是需要提示的内容
        self.$message.error(info)
      },
    }
    var editorEdit = new E('#deptsContentMenu', '#deptsContent')
    editorEdit.customConfig = editorConfig
    this.editorEdit = editorEdit
    this.editorEdit.create()
    // 特别注意：由于wangeditor v3没有支持line-height和font-size，所以需要自己css设置，于是我们在编辑器区域设置font-size:16px;line-height:1.6; 在获取编辑器html同时，在最外层包裹<div style="font-size:16px;line-height:1.6" class="chinacaring-style"></div>，以达到同编辑框样式一致的效果,chinacaring-style为了增加内容样式可编辑性
    //     var editorAdd = new E('#deptAddContentMenu', '#deptAddContent')
    //     editorAdd.customConfig = editorConfig
    //     this.editorAdd = editorAdd
  },
}
</script>

<style lang="less">
#depts .el-tree-node__content {
  height: 30px;
}
.iconc {
  transform: rotate(90deg);
  color: #606266;
}
#depts .w-e-toolbar {
  border: 1px solid #d8dce5;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 5px 0;
  line-height: 0;
  background-color: rgba(0, 0, 0, 0.08);
}
#depts .deptsContent {
  height: 500px;
  border: 1px solid #d8dce5;
  border-top: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  line-height: 1.6;
  font-size: 16px;
  padding: 5px 0;
}
#depts .deptAddContent {
  height: 400px;
  border: 1px solid #d8dce5;
  border-top: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  line-height: 1.6;
  font-size: 16px;
  padding: 5px 0;
}
#depts .editInfo img {
  max-width: 100%;
  height: auto;
}
#depts .cc-tree {
  font-size: 14px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#depts .cc-tree i.fa {
  font-size: 16px;
  margin-right: 3px;
  color: #777;
  width: 20px;
}
#depts .cc-tree i.fa.fa-ellipsis-v {
  color: #ccc;
}
</style>
